import { render, staticRenderFns } from "./NpaHistoryChangesView.vue?vue&type=template&id=6cd0f6cc&scoped=true"
import script from "./NpaHistoryChangesView.vue?vue&type=script&lang=js"
export * from "./NpaHistoryChangesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd0f6cc",
  null
  
)

export default component.exports